import { SvgIcon } from "@mui/material";
import React from "react";

const ImportIcon = ({ fill }) => {
  return (
    <SvgIcon>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.7666 9.73328L9.89994 11.8666L12.0333 9.73328"
          stroke={fill || "#DC585C"}
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.8999 3.33337V11.8084"
          stroke={fill || "#DC585C"}
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.6668 10.15C16.6668 13.8334 14.1668 16.8167 10.0002 16.8167C5.8335 16.8167 3.3335 13.8334 3.3335 10.15"
          stroke={fill || "#DC585C"}
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
};

export default ImportIcon;
